"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uncachedQueries = void 0;
exports.uncachedQueries = [
    'UserDetails',
    'getWishlists',
    'getCart',
    'getApplePayCart',
    'getOnsiteOrderTrackingOrders',
    'getSampleOptions',
];
//# sourceMappingURL=uncachedGQLQueries.js.map